import { render, staticRenderFns } from "./FailedSubjects.vue?vue&type=template&id=629d3b46&scoped=true"
import script from "./FailedSubjects.vue?vue&type=script&lang=js"
export * from "./FailedSubjects.vue?vue&type=script&lang=js"
import style0 from "./FailedSubjects.vue?vue&type=style&index=0&id=629d3b46&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "629d3b46",
  null
  
)

export default component.exports